import { ENDS, ETaxVariant } from 'cashbox';

export type TGroup = {
  id: number;
  title: string;
  company_id?: number;
  goods?: TGood[];
  sell_periods: { start: number; end: number }[];
  show_in_shell: boolean;
  quantity?: number;
};

export interface ILowStockNotification {
  enabled: boolean;
  threshold?: number;
}

export type TGood = {
  id: number;
  cost: number;
  amount: number;
  title: string;
  wholesale_cost: number;
  use_global_discounts: boolean;
  eans: [string] | [];
  vat: ENDS | null;
  tax_system: ETaxVariant | null;
  use_fair_sign: boolean;
  comment?: string;
  is_excise: boolean;
  category: TGroup | null;
  image: null | string;
  discount: boolean;
  show_in_shell: boolean;
  cost_of_balanced: number;
  in_combo: boolean;
  low_stock_notification: ILowStockNotification | null;
  highlighted: boolean;
  available_to_buy: boolean;
};

export type TGoodsMinimal = Pick<TGood, 'id' | 'title' | 'amount'>;

export type TShopGood = Pick<
  TGood,
  | 'id'
  | 'title'
  | 'cost'
  | 'amount'
  | 'use_global_discounts'
  | 'eans'
  | 'vat'
  | 'tax_system'
  | 'use_fair_sign'
  | 'is_excise'
  | 'category'
  | 'available_to_buy'
>;

export enum EGoodsAmountOperating {
  ADD = 'ADD',
  REFUND = 'REFUND',
  DISPOSAL = 'DISPOSAL',
  SOLD = 'SOLD',
  CREATE = 'CREATE',
  SET = 'SET',
}
